import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiFlash';

import { all, put, takeEvery } from 'redux-saga/effects';
import {
  OFFLINE_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
} from '../../shared/constants/Constants';
import {
  flashCardIndex,
  ListOfCards,
  Logout,
  startLoading,
  stopLoading,
  update_flashcard_details,
  upDateFlashCardCount,
} from '../actions';
// import {
//     GetTotalNumberofFlashcards_URL,POST_METHOD
//   } from "../../shared/Apis/api";
// import { getRequest, putRequestNoAuth ,postRequest} from '../../shared/services/axios';
import { checkOffline } from '../../shared/services/Utility';

function* fetchFlashCardCount(action) {
  try {

    if (action.value) {
      yield put(startLoading());
    }

    const data = yield api.fetchFlashCardCount(action.userId);

    if (data.status === 1) {
      yield put(upDateFlashCardCount(data.flashCardCount));
      action.success(data.flashCardCount);

      // yield put(stopLoading());
    } else if (data.status === SESSION_EXPIRED_CODE) {
      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());

    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }

  }
}

function* fetchListOfCards(action) {
  try {
    if (action.value) {
      yield put(startLoading());
    }
    const data = yield api.fetchListOfCards(action.flashcardDetails);
    if (data.status === 1) {
      yield put(ListOfCards(data.flashcardData.flashcardDetails));
      yield put(update_flashcard_details(data.flashcardData.savedFlashData));
      let savedCards = data.flashcardData.savedFlashData;
      if (savedCards) {
        let viewedlist = savedCards.filter((value) => value?.isViewed);
        yield put(flashCardIndex(viewedlist?.length));
      }
      yield put(stopLoading());

    } else if (data.status === SESSION_EXPIRED_CODE) {
      yield put(stopLoading());
      /*session id expired*/
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
  }
}

function* submitFlashcardDetails(action) {
  try {

    const data = yield api.submitFlashcardDetails_API(
      action.userFlashcardDetails,
    );
    if (data.status === 1) {

    } else if (data.status === SESSION_EXPIRED_CODE) {

      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
  } catch (e) {
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }

  }
}

function* FlashSaga() {
  yield all([
    takeEvery(actionTypes.FLASHCARD_COUNT_REQUEST, fetchFlashCardCount),
    takeEvery(actionTypes.FLASHCARD_LIST_REQUEST, fetchListOfCards),
    takeEvery(actionTypes.USER_FLASHCARD_DETAILS, submitFlashcardDetails),
  ]);
}

export default FlashSaga;
